import React from "react";
import { Button, Modal } from "../../../components/ui";

export interface ApprovePreconsultationModalProps {
  /** Whose answers are being accepted, by first name. */
  firstName: string;
  /** Whether the call is already out. */
  busy: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

/**
 * The last step before a client's answers are taken onto their record.
 *
 * Worth a press of its own because accepting merges: the height, the weight and
 * the rest land on the client and stay there, and a practitioner who meant to
 * open the form and read it first should not find they have agreed to it by
 * clicking the wrong one of two buttons standing side by side.
 *
 * The confirm is the brand's own teal rather than the strip's green. This is an
 * ordinary write to a record — the green on the strip was there to read as
 * yes-against-no beside a red, and there is nothing to weigh it against here.
 */
const ApprovePreconsultationModal: React.FC<
  ApprovePreconsultationModalProps
> = ({ firstName, busy, onConfirm, onClose }) => (
  <Modal
    open
    title={`Approve ${firstName}'s details?`}
    onClose={onClose}
    // Asking rather than showing: a stray click beside the panel is far more
    // likely a miss than an answer.
    dismissOnBackdrop={false}
    className="max-w-[500px]"
    footer={
      <div className="flex flex-wrap items-center justify-end gap-3">
        <Button
          size="md"
          variant="secondary"
          onClick={onClose}
          disabled={busy}
        >
          Cancel
        </Button>
        <Button size="md" onClick={onConfirm} loading={busy}>
          Approve
        </Button>
      </div>
    }
  >
    <p className="text-[14px] 3xl:text-[15px] text-ink-muted">
      This confirms the health data looks correct. It stays on {firstName}&rsquo;s
      profile.
    </p>
  </Modal>
);

export default ApprovePreconsultationModal;
